/**
 * Store: Size guide drawer
 * -----------------------------------------------------------------------------
 * Handles size guide drawer actions
 */

export default {
  namespaced: true,

  state: () => ({
    product: false,
  }),

  getters: {

    /**
     * Get the current active product for ATC
     * @returns {Object}
     */
    getCurrentProduct(state) {
      return state.product
    },
  },

  mutations: {

    /**
     * Set product.
     */
    SET_PRODUCT(state, product) {
      state.product = product
    },
  },

  actions: {

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setSizeGuideProduct({ commit }, product = false) {
      commit('SET_PRODUCT', product)
    },
  },
}
